export default theme => ({ // eslint-disable-line
    twoColumnWrapper: {
        padding: '50px 0',
        [theme.breakpoints.up('md')]: {
            padding: '140px 0',
        }
    },
})